/* DC — assets/dc-megamenu.js : panneau « Boutique » de l'ordinateur (#dc-mm) et tiroir du téléphone (#dc-mnav).
   DC 29/10/2026 : réécrit lisiblement pour le méga-menu « trois portes » (maquette C validée par Marco le 29/10 ;
   balisage : snippets/dc-megamenu.liquid ; styles : assets/dc-megamenu.css).
   Gardé d'avant : ouverture au clic sur « Boutique » (ordinateur) et sur le burger (téléphone), placement sous la pilule
   (placePanel), fermeture des autres fenêtres (loupe, panier, compte), voile html.dc-mm-open, burger en croix
   (html.dc-nav-open), Échap, toucher dehors, repositionnement au défilement et au redimensionnement. Les attributs du lien
   « Boutique » de l'en-tête ne sont jamais touchés : le thème Horizon y accroche son propre sous-menu.
   Nouveau :
   - trois portes (onglets) « Rayons », « Marques », « Par où commencer ? » : clic, souris posée 120 ms (ordinateur),
     flèches gauche/droite, Début, Fin ; aria-selected tenu à jour ;
   - ordinateur : s'ouvre toujours sur « Rayons » ; sa hauteur ne bouge pas d'une porte à l'autre (CSS) ; Tab depuis
     « Boutique » entre dans le panneau (porte choisie), Maj+Tab en ressort, Tab après le dernier lien referme et passe à la
     rubrique suivante de l'en-tête ; Échap referme et rend le focus à « Boutique » ;
   - téléphone : s'ouvre là où l'on est, d'après la classe dc-current posée par layout/theme.liquid (rayon ou étagère :
     « Rayons », son univers déplié ; marque : « Marques » ; ailleurs : « Rayons ») ; rien n'est mesuré ni défilé dans la
     première image : l'état est posé tiroir caché, et le défilement éventuel attend deux images ;
   - téléphone : le Retour d'Android referme le tiroir au lieu de quitter la page (greffe de la direction B) ;
   - le fondu d'ouverture est une animation CSS : aucune relecture du style entre « affiché » et « ouvert ».
   Vitesse (mesuré sur l'aperçu le 29/10, traces Chrome) : l'attribut hidden n'est plus jamais retiré ni remis (panneau,
   tiroir, vues des portes, étagères) : chaque changement de hidden faisait recalculer le style de toute la page (règle
   :has() du thème) ; tout passe par des classes (dco--vu, is-on, dco--deplie). Au téléphone, le voile de la page
   (html.dc-mm-open) est posé à la fin du fondu du tiroir : cette classe fait elle aussi recalculer toute la page (règle
   touch-action du body, snippets/dc-glass.liquid, non modifié), elle ne retarde ainsi plus l'apparition du tiroir ; même
   moment pour aria-expanded de l'univers déplié d'office (attribut lu par des règles :has() du thème).
   Correction du 29/10 après vérification adverse : le clic d'ouverture ne lit plus window.innerWidth (lecture qui forçait,
   au téléphone, le recalcul de toute la page dans le clic) ; placePanel lit tout avant d'écrire ; l'entrée d'historique
   du bouton Retour est posée juste après la première image ; à l'ordinateur, sur un écran bas, la ligne des 6 étapes se
   colle en bas du panneau (classe dco--serre).
   DC 29/10/2026 au soir (demande de Marco après l'aperçu sur son téléphone : « le menu n'est pas assez lisible et je veux
   que boutique reste à sa place. accueil etc doivent rester au même niveau ») — téléphone seulement, l'ordinateur ne
   change pas :
   - le tiroir s'ouvre sur les six rubriques (Accueil, Boutique, Formations, PPF, Accréditations, Contact) ; Boutique est
     une rangée pliable (dco__pli) comme les univers : au toucher elle se déplie sur place, sous sa ligne, sans faire
     défiler le tiroir, et montre les trois portes ;
   - « là où l'on est » : étagère ou univers -> Boutique dépliée, « Rayons », l'univers déplié, le lien marqué ; marque ->
     Boutique dépliée sur « Marques » (la marque centrée si elle est hors de vue) ; ailleurs (accueil, rubriques, toute la
     boutique, fiches produit…) -> les six rubriques, Boutique repliée ;
   - changer de porte ne renvoie plus le tiroir en haut : si la barre des portes est sortie par le haut, elle revient
     juste en haut du tiroir ;
   - la police des étagères et des marques (« DC Manrope Menu », Manrope en 500 ; assets/dc-megamenu.css) est demandée au
     repos, au téléphone seulement, pour que la première ouverture l'ait déjà.
   DC 03/11/2026 (décision de Marco des 02-03/11 : « C'est parfait le menu comme ça ») — téléphone seulement, l'ordinateur
   ne change pas : le tiroir est de nouveau celui du SITE EN LIGNE (snippets/dc-megamenu.liquid, sans la classe « dco »),
   avec une ligne « Marques » sous Boutique. Ce fichier reprend donc pour #dc-mnav les gestes du site en ligne :
   - ouverture : le tiroir s'affiche (dco--vu), puis s'ouvre (is-open) à l'image suivante, plus un filet à 90 ms, comme en
     ligne : le fondu de 0,22 s de snippets/dc-glass.liquid joue ; le voile de la page (dc-mm-open) est posé tout de suite ;
   - fermeture : il sort de la page 340 ms après (fin du fondu) ; 360 ms après, Boutique, Marques et les univers sont
     repliés (hidden, chevron remis, aria-expanded à « false ») ;
   - Boutique [data-shop] et Marques [data-marques] : chacun bascule SA boîte (aria-controls, sinon la boîte qui suit le
     bouton), indépendamment l'un de l'autre ; univers (.dcnav__tile) : accordéon, une seule rangée ouverte à la fois, la
     sous-liste glisse en vue 220 ms après ; sous-listes relogées sous leur tuile au chargement (batir, repris de
     layout/theme.liquid du site en ligne) ;
   - comme aujourd'hui en ligne : le tiroir ne s'ouvre pas sur la page en cours (preparer, ici et montrerIci ne servent
     plus qu'à l'ordinateur) et le Retour d'Android ne le ferme pas : l'entrée d'historique n'est posée que si #dc-mnav
     porte l'attribut data-dc-retour (absent aujourd'hui ; à proposer plus tard). */
(function () {
  if (window.__dcMM) return; window.__dcMM = 1;
  var R = document.documentElement;
  var reduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var FENETRES = ['dc-mm', 'dc-mnav', 'dc-search', 'dc-cart', 'dc-acc'];
  function $g(id) { return document.getElementById(id); }
  function isOpen(b) { return !!b && b.classList.contains('is-open'); }
  function unlock() { try { var b = document.body; if (!(b && b.style && b.style.position === 'fixed')) return; var ty = b.style.top; var y = ty ? (Math.abs(parseInt(ty, 10)) || 0) : 0; var sb = R.style.scrollBehavior; R.style.scrollBehavior = 'auto'; b.style.position = ''; b.style.top = ''; b.style.width = ''; b.style.left = ''; b.style.right = ''; b.style.overflow = ''; window.scrollTo(0, y); R.style.scrollBehavior = sb; } catch (e) {} }
  function killDrawer() { try { var d = $g('Details-menu-drawer-container'); if (d && d.hasAttribute('open')) { d.removeAttribute('open'); unlock(); } } catch (e) {} }
  /* ordinateur ou téléphone : retenu au chargement et à chaque redimensionnement (plus bas). DC 29/10/2026 (correction) :
     plus aucune lecture de window.innerWidth pendant l'ouverture : au téléphone, Chrome recalcule alors le style et la mise
     en page de toute la page sur-le-champ (74 à 146 ms au processeur ×4, mesuré par la vérification adverse). */
  var lastDesk = window.innerWidth >= 1000;
  /* sous la pilule, à 8 px ; hauteur limitée à l'écran (12 px en bas) ; à l'ordinateur, mêmes bords que la pilule.
     Toutes les lectures d'abord, les écritures ensuite : aucune mise en page forcée entre deux. */
  function placePanel(box, sel) {
    var pill = document.querySelector('.header__row--top'); if (!pill || !box) return;
    var pr = pill.getBoundingClientRect(), ih = window.innerHeight, pn = box.querySelector(sel);
    var tp = Math.max(8, pr.bottom + 8); box.style.top = tp + 'px';
    if (pn) { pn.style.maxHeight = Math.max(180, ih - tp - 12) + 'px'; if (box.id === 'dc-mm') { pn.style.marginLeft = pr.left + 'px'; pn.style.width = pr.width + 'px'; pn.style.maxWidth = 'none'; } }
  }
  /* ordinateur, écran bas (portable 1366×768 : environ 640 px utiles) : le panneau défile, et la ligne des 6 étapes
     resterait sous le bord. La classe dco--serre la colle alors en bas du panneau (assets/dc-megamenu.css), visible sans
     clic (condition 2 de Marco). Lu deux images après l'ouverture (panneau déjà peint) ou au redimensionnement. */
  var serreF = 0;
  function serreBientot() {
    if (serreF) return;
    serreF = requestAnimationFrame(function () { serreF = requestAnimationFrame(function () {
      serreF = 0; var mm = $g('dc-mm'), pn = mm && mm.querySelector('.dcmm__panel'); if (!pn || !isOpen(mm)) return;
      var s = pn.scrollHeight > pn.clientHeight + 1;
      if (s !== mm.classList.contains('dco--serre')) mm.classList.toggle('dco--serre', s);
    }); });
  }
  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); if (r.width < 1 || r.height < 1) return false; var s = getComputedStyle(el); return s.visibility !== 'hidden' && s.display !== 'none'; }
  function lienBoutique() { var l = document.querySelectorAll('#header-group a'); for (var i = 0; i < l.length; i++) { if ((l[i].textContent || '').trim().toLowerCase() === 'boutique' && l[i].getBoundingClientRect().width > 0) return l[i]; } return null; }
  function suivantEntete(lb) { var l = [].slice.call(document.querySelectorAll('#header-group a[href], #header-group button, #header-group summary')).filter(visible); var i = l.indexOf(lb); return i >= 0 ? l[i + 1] : null; }

  /* ------------------------------------------------------------------ portes */
  function portes(b) { return [].slice.call(b.querySelectorAll('.dco__tab')); }
  /* o.anim : changement de porte par la personne (fondu court de la vue, tiroir remis en haut) ; o.focus : la porte prend le focus */
  function choisir(b, t, o) {
    o = o || {};
    var tel = b.id === 'dc-mnav';
    portes(b).forEach(function (x) {
      var on = x === t, avant = x.getAttribute('aria-selected') === 'true', v = $g(x.getAttribute('aria-controls'));
      if (on !== avant) { x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; }
      if (!v) return;
      if (on !== v.classList.contains('is-on')) v.classList.toggle('is-on', on);
      if (!on) v.classList.remove('dco--entre');
      else if (!avant && o.anim && !reduit.matches) v.classList.add('dco--entre');
    });
    if (o.focus) t.focus();
    /* téléphone (29/10 au soir) : le tiroir ne repart plus en haut ; seule la barre des portes, si elle est sortie par le
       haut, revient juste en haut de la partie qui défile */
    if (tel && o.anim) {
      var p = b.querySelector('.dco__defil'), bar = b.querySelector('.dco__bar');
      if (p && bar) { var pr = p.getBoundingClientRect(), br = bar.getBoundingClientRect(); if (br.top < pr.top - 1) p.scrollTop = Math.max(0, p.scrollTop + br.top - pr.top); }
    }
  }
  document.addEventListener('animationend', function (e) { var v = e.target; if (e.animationName === 'dcoVue' && v.classList) v.classList.remove('dco--entre'); });

  /* ------------------------------------------------------------------ téléphone : rangées pliables (Boutique et les univers) */
  /* DC 29/10/2026 au soir : une rangée pliable porte la classe dco__pli ; son premier enfant est le bouton, sa boîte est
     l'enfant .dco__pbox. Une seule rangée ouverte à la fois parmi ses sœurs (les univers entre eux ; Boutique n'a que des
     liens pour sœurs).
     Une rangée fermée sort de la page (sans la classe dco--deplie) ; sa boîte glisse seulement quand on la déplie au doigt.
     instant : état posé tiroir caché, à l'ouverture ; aria-expanded est alors mis à jour plus tard par ariaU (voir openBox) :
     l'attribut figure dans des règles :has() du thème (cartes produit, en-tête), le changer fait recalculer toute la page. */
  function bouton(li) { var x = li.firstElementChild; return x && x.tagName === 'BUTTON' ? x : null; }
  function boite(li) { for (var x = li.firstElementChild; x; x = x.nextElementSibling) if (x.classList.contains('dco__pbox')) return x; return null; }
  function ariaU(b) {
    b.querySelectorAll('.dco__pli').forEach(function (li) {
      var bt = bouton(li), v = li.classList.contains('is-open') ? 'true' : 'false';
      if (bt && bt.getAttribute('aria-expanded') !== v) bt.setAttribute('aria-expanded', v);
    });
  }
  function fermerU(li, instant) {
    var bt = bouton(li);
    li.classList.remove('is-open'); if (!instant && bt && bt.getAttribute('aria-expanded') !== 'false') bt.setAttribute('aria-expanded', 'false');
    clearTimeout(li.__dcT);
    if (instant || reduit.matches) li.classList.remove('dco--deplie');
    else li.__dcT = setTimeout(function () { if (!li.classList.contains('is-open')) li.classList.remove('dco--deplie'); }, 260);
  }
  function ouvrirU(b, li, instant) {
    var soeurs = li.parentElement ? li.parentElement.children : [];
    for (var i = 0; i < soeurs.length; i++) if (soeurs[i] !== li && soeurs[i].classList.contains('is-open')) fermerU(soeurs[i], instant);
    var s = boite(li), bt = bouton(li);
    clearTimeout(li.__dcT);
    if (s) { li.classList.add('dco--deplie'); if (!instant) void s.offsetHeight; /* au doigt : départ du glissement à 0 */ }
    li.classList.add('is-open'); if (!instant && bt) bt.setAttribute('aria-expanded', 'true');
  }
  /* après un dépliage au doigt : si les étagères sortent par le bas, le tiroir glisse juste assez pour les montrer */
  function suivre(b, li) {
    setTimeout(function () {
      var p = b.querySelector('.dco__defil'); if (!p || !li.classList.contains('is-open')) return;
      var pr = p.getBoundingClientRect(), r = li.getBoundingClientRect();
      var top = p.scrollTop, bas = r.bottom - pr.top + p.scrollTop + 6, haut = r.top - pr.top + p.scrollTop;
      if (bas > top + p.clientHeight) top = Math.min(haut, bas - p.clientHeight);
      if (top !== p.scrollTop) { try { p.scrollTo({ top: top, behavior: reduit.matches ? 'auto' : 'smooth' }); } catch (e) { p.scrollTop = top; } }
    }, reduit.matches ? 0 : 250);
  }

  /* ------------------------------------------------------------------ téléphone : « là où l'on est » */
  /* lien de la page en cours (dc-current, layout/theme.liquid) :
     - dans les univers de « Rayons » (étagère, « Tout … », Moteur, Kits) -> Boutique dépliée sur Rayons, l'univers déplié ;
     - sinon dans « Marques » -> Boutique dépliée sur Marques, sauf si la page est aussi une rubrique du niveau 1 (PPF :
       Skyfol et Terminax y mènent aussi) ;
     - ailleurs (accueil, rubriques, toute la boutique, fiches produit…) -> les six rubriques, Boutique repliée, Rayons prêt.
     DC 29/10/2026 au soir : « Toute la boutique » (/collections/all) n'ouvre plus Boutique : seules l'étagère et la marque
     le font (demande du jour : ailleurs, le niveau 1). */
  function ici(b) {
    var l = b.querySelectorAll('a.dc-current'), r = null, m = null, rubrique = false;
    for (var i = 0; i < l.length; i++) {
      if (l[i].classList.contains('dco__l1')) { rubrique = true; continue; }
      var v = l[i].closest('.dco__view'), k = v && v.getAttribute('data-vue');
      if (k === 'rayons' && l[i].closest('.dco__acc')) { if (!r) r = l[i]; } else if (k === 'marques') { if (!m) m = l[i]; }
    }
    if (r) return { boutique: true, vue: 'rayons', lien: r };
    if (m && !rubrique) return { boutique: true, vue: 'marques', lien: m };
    return { boutique: false, vue: 'rayons', lien: null };
  }
  /* pose l'état d'ouverture tiroir encore caché (display:none) : que des écritures, aucune mesure, aucune transition */
  function preparer(b) {
    var tel = b.id === 'dc-mnav', cible = tel ? ici(b) : { vue: 'rayons', lien: null };
    var t = b.querySelector('.dco__tab[aria-controls$="-v-' + cible.vue + '"]');
    if (t) choisir(b, t);
    if (!tel) return null;
    b.querySelectorAll('.dco__acc>li.is-open').forEach(function (x) { fermerU(x, true); });
    var bq = b.querySelector('.dco__bq');
    if (bq) { if (cible.boutique) ouvrirU(b, bq, true); else fermerU(bq, true); }
    var li = cible.lien && cible.lien.closest('.dco__acc>li');
    if (li && li.classList.contains('dco__pli')) ouvrirU(b, li, true);
    return cible.lien;
  }
  /* deux images plus tard (tiroir déjà peint, encore presque transparent) : si le lien de la page n'est pas en entier dans
     la partie qui défile, on la place d'un coup : étagère -> son univers en haut ; marque -> la marque au milieu */
  function montrerIci(b, a) {
    if (!a) return;
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      var p = b.querySelector('.dco__defil'); if (!isOpen(b) || !p) return;
      var pr = p.getBoundingClientRect(), ar = a.getBoundingClientRect();
      if (ar.top >= pr.top && ar.bottom <= pr.bottom) return;
      var li = a.closest('.dco__acc>li'), top;
      if (li) {
        top = li.getBoundingClientRect().top - pr.top + p.scrollTop;
        var bas = ar.bottom - pr.top + p.scrollTop + 8;
        if (bas - top > p.clientHeight) top = bas - p.clientHeight;
      } else top = (ar.top + ar.bottom) / 2 - pr.top + p.scrollTop - p.clientHeight / 2;
      p.scrollTop = Math.max(0, Math.min(top, p.scrollHeight - p.clientHeight));
    }); });
  }

  /* ------------------------------------------------------------------ téléphone : bouton Retour d'Android */
  /* une entrée d'historique (même adresse) à l'ouverture du tiroir ; Retour la consomme et referme le tiroir. Toute autre
     fermeture la retire (history.back, popstate ignoré) : croix, toucher dehors, Échap, passage à l'ordinateur, et la
     loupe, le panier, le compte ou l'ajout rapide qui ferment le tiroir eux-mêmes (observateur, greffe de la direction B).
     Un lien suivi depuis le tiroir retire d'abord l'entrée puis navigue : un seul Retour ramène à la page de départ. */
  /* DC 29/10/2026 (correction) : l'entrée est posée juste APRÈS la première image du tiroir, et seulement s'il est toujours
     ouvert : history.pushState coûtait 33 à 43 ms au processeur ×4 dans le clic (mesuré sur l'aperçu). Si le retour d'une
     fermeture précédente n'est pas encore arrivé, l'entrée attend ce retour (sinon il reprendrait la nouvelle entrée :
     ouvrir, fermer, rouvrir en moins de 60 ms laissait le tiroir ouvert sans entrée — relevé par la vérification adverse). */
  var arme = false, ignorer = 0, allerA = null, allerT = 0, entrerF = 0, enAttente = false;
  function histEntrer() {
    /* DC 03/11/2026 : interrupteur éteint par défaut (comme le site en ligne, le Retour ne ferme pas le tiroir) */
    var nvR = $g('dc-mnav'); if (!nvR || !nvR.hasAttribute('data-dc-retour')) return;
    if (arme || lastDesk || !isOpen(nvR)) return;
    if (ignorer > 0) { enAttente = true; return; }
    try { history.pushState({ dcMenu: 1 }, ''); arme = true; } catch (e) {}
  }
  function histEntrerBientot() { cancelAnimationFrame(entrerF); entrerF = requestAnimationFrame(function () { setTimeout(histEntrer, 0); }); }
  function histSortir() { enAttente = false; if (!arme) return; arme = false; ignorer++; try { history.back(); } catch (e) { ignorer--; aller(); } }
  function aller() { if (!allerA) return; var h = allerA; allerA = null; clearTimeout(allerT); location.href = h; }
  window.addEventListener('popstate', function () {
    if (ignorer > 0) { ignorer--; aller(); if (!ignorer && enAttente) { enAttente = false; histEntrer(); } return; }
    if (!arme) return;
    arme = false;
    var nv = $g('dc-mnav'); if (isOpen(nv)) { closeBox(nv); syncBlur(); }
  });
  /* page rechargée tiroir ouvert : l'entrée laissée n'a plus de tiroir à fermer */
  try { if (history.state && history.state.dcMenu) history.replaceState(null, ''); } catch (e) {}

  /* ------------------------------------------------------------------ ouvrir / fermer */
  /* la fenêtre reste affichée (classe dco--vu) le temps du fondu de fermeture, puis sort de la page.
     DC 03/11/2026 : tiroir du téléphone à 340 ms, comme le site en ligne (fondu de 0,22 s de dc-glass) */
  function cacherApres(b) {
    clearTimeout(b.__dcT);
    b.__dcT = setTimeout(function () { if (!isOpen(b)) b.classList.remove('dco--vu'); }, reduit.matches ? 0 : (b.id === 'dc-mnav' ? 340 : 220));
  }
  /* ------------------------------------------------------------------ téléphone : tiroir du site en ligne (DC 03/11/2026) */
  /* la boîte d'un bouton Boutique ou Marques : celle que nomme aria-controls, sinon la boîte .dcnav__shop qui suit le bouton
     (jamais « la première .dcnav__shop » du tiroir : il y en a deux) */
  function boiteDe(bt) {
    var id = bt.getAttribute('aria-controls'), x = id ? $g(id) : null; if (x) return x;
    for (x = bt.nextElementSibling; x; x = x.nextElementSibling) if (x.classList.contains('dcnav__shop')) return x;
    return null;
  }
  /* tiroir refermé : Boutique, Marques et les univers repliés (comme resetShop du site en ligne, plus Marques et aria-expanded) */
  function replier(b) {
    b.querySelectorAll('.dcnav__shop').forEach(function (x) { if (!x.hidden) x.hidden = true; });
    b.querySelectorAll('[data-shop],[data-marques]').forEach(function (x) { x.classList.remove('is-x'); if (x.getAttribute('aria-expanded') !== 'false') x.setAttribute('aria-expanded', 'false'); });
    b.querySelectorAll('.dcnav__tile').forEach(function (x) { x.classList.remove('is-on'); if (x.getAttribute('aria-expanded') === 'true') x.setAttribute('aria-expanded', 'false'); });
    b.querySelectorAll('.dcnav__sub').forEach(function (x) { if (!x.hidden) x.hidden = true; });
  }
  /* au chargement (repris de layout/theme.liquid du site en ligne) : chaque sous-liste d'univers est relogée juste sous sa
     tuile (accordéon) ; aria-expanded à « false » pour les tuiles, Boutique et Marques. Une seule fois (data-dc-acc). */
  function batir() {
    var nav = $g('dc-mnav'); if (!nav) return;
    var wrap = nav.querySelector('.dcnav__tiles');
    if (!wrap || wrap.dataset.dcAcc) return;
    wrap.dataset.dcAcc = '1';
    var tiles = wrap.querySelectorAll('.dcnav__tile');
    for (var i = 0; i < tiles.length; i++) {
      var sub = $g(tiles[i].getAttribute('data-u'));
      if (sub) tiles[i].insertAdjacentElement('afterend', sub);
      tiles[i].setAttribute('aria-expanded', 'false');
    }
    nav.querySelectorAll('[data-shop],[data-marques]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
  }
  batir();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', batir);
  setTimeout(batir, 500); setTimeout(batir, 1500);
  function closeBox(b) {
    if (!b || !isOpen(b)) return;
    b.classList.remove('is-open');
    if (b.id === 'dc-mnav') {
      R.classList.remove('dc-nav-open'); b.__dcJ = 0;
      setTimeout(function () { if (!isOpen(b)) replier(b); }, 360);
    }
    cacherApres(b);
  }
  /* toute fermeture, même faite par la loupe, le panier, le compte ou l'ajout rapide (ils retirent is-open eux-mêmes) :
     la fenêtre sort de la page après son fondu, et l'entrée d'historique du tiroir est retirée (greffe de la direction B).
     DC 03/11/2026 (correction) : la sortie de page n'est programmée que si is-open vient d'être RETIRÉ. Avant, l'ajout de
     dco--vu à l'ouverture du tiroir (is-open posé seulement à l'image suivante) la programmait aussi : en mouvement réduit
     (délai 0 ms) dco--vu tombait avant l'image suivante et le tiroir ne s'ouvrait jamais (clic de TalkBack ou par script). */
  var RE_OUVERT = /(^|\s)is-open(\s|$)/;
  ['dc-mm', 'dc-mnav'].forEach(function (id) {
    var b = $g(id); if (!b || !window.MutationObserver) return;
    try { new MutationObserver(function (recs) {
      if (isOpen(b)) return;
      var ferme = false; for (var i = 0; i < recs.length; i++) if (RE_OUVERT.test(recs[i].oldValue || '')) { ferme = true; break; }
      if (ferme && b.classList.contains('dco--vu')) cacherApres(b);
      if (id === 'dc-mnav' && arme) histSortir();
    }).observe(b, { attributes: true, attributeFilter: ['class'], attributeOldValue: true }); } catch (e) {}
  });
  var ouvertures = 0;
  function syncBlur() { for (var i = 0; i < FENETRES.length; i++) { if (isOpen($g(FENETRES[i]))) { R.classList.add('dc-mm-open'); return; } } R.classList.remove('dc-mm-open'); }
  function openBox(box, sel) {
    if (!box) return; killDrawer();
    FENETRES.forEach(function (id) { var o = $g(id); if (o && o !== box) closeBox(o); });
    clearTimeout(box.__dcT);
    placePanel(box, sel);
    if (box.id === 'dc-mnav') {
      /* DC 03/11/2026 : tiroir du site en ligne, mêmes temps qu'en ligne : affiché tout de suite (dco--vu), voile de la page et
         burger en croix tout de suite, ouvert (is-open) à l'image suivante avec un filet à 90 ms, pour que le fondu de 0,22 s
         (snippets/dc-glass.liquid) parte de l'état fermé. Il s'ouvre toujours replié, sur les rubriques (pas sur la page en cours). */
      var j = box.__dcJ = ++ouvertures;
      /* DC 03/11/2026 (correction) : en mouvement réduit il n'y a pas de fondu à attendre, le tiroir est ouvert tout de suite */
      box.classList.add('dco--vu'); if (reduit.matches) box.classList.add('is-open');
      R.classList.add('dc-mm-open'); R.classList.add('dc-nav-open');
      var sh = function () { if (box.__dcJ === j && box.classList.contains('dco--vu') && !isOpen(box)) box.classList.add('is-open'); };
      requestAnimationFrame(sh); setTimeout(sh, 90);
      histEntrerBientot();
    } else {
      preparer(box);
      box.classList.add('dco--vu', 'is-open');
      R.classList.add('dc-mm-open'); serreBientot();
    }
    setTimeout(killDrawer, 60); setTimeout(killDrawer, 200);
  }
  function closeMenus() { closeBox($g('dc-mm')); closeBox($g('dc-mnav')); syncBlur(); }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var ham = t.closest('summary.header__icon--menu, .header__icon--menu');
    if (ham) { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); killDrawer(); var nv = $g('dc-mnav'); if (isOpen(nv)) { closeBox(nv); syncBlur(); } else { openBox(nv, '.dcnav__panel'); } return; }
    /* DC 03/11/2026 : tiroir du site en ligne. Boutique [data-shop] et Marques [data-marques] basculent chacun SA boîte, sans
       toucher à l'autre ; le chevron se retourne (is-x). Avant le test « dans le panneau » plus bas, qui avalerait le toucher. */
    var sb = t.closest('#dc-mnav [data-shop], #dc-mnav [data-marques]');
    if (sb) { e.preventDefault(); var bx = boiteDe(sb); if (bx) { bx.hidden = !bx.hidden; sb.classList.toggle('is-x', !bx.hidden); sb.setAttribute('aria-expanded', bx.hidden ? 'false' : 'true'); } return; }
    /* univers : accordéon, une seule rangée ouverte à la fois ; 220 ms après, la sous-liste ouverte glisse en vue (comme en ligne) */
    var tl = t.closest('#dc-mnav .dcnav__tile');
    if (tl) {
      e.preventDefault(); var nv3 = $g('dc-mnav'), on = tl.classList.contains('is-on');
      nv3.querySelectorAll('.dcnav__tile.is-on').forEach(function (x) { x.classList.remove('is-on'); if (x !== tl) x.setAttribute('aria-expanded', 'false'); });
      nv3.querySelectorAll('.dcnav__sub').forEach(function (x) { x.hidden = true; });
      if (!on) { var sub = $g(tl.getAttribute('data-u')); if (sub) { tl.classList.add('is-on'); sub.hidden = false; } }
      setTimeout(function () {
        var o = tl.classList.contains('is-on'); tl.setAttribute('aria-expanded', o ? 'true' : 'false');
        if (o) { var s2 = $g(tl.getAttribute('data-u')); (s2 || tl).scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
      }, 220);
      return;
    }
    var tab = t.closest('#dc-mm .dco__tab, #dc-mnav .dco__tab');
    if (tab) { e.preventDefault(); choisir(tab.closest('#dc-mm, #dc-mnav'), tab, { anim: true }); return; }
    /* rangée pliable : un univers suit ses étagères si elles sortent par le bas ; Boutique se déplie sur place, sans défiler */
    var mu = t.closest('#dc-mnav .dco__pli>button');
    if (mu) { e.preventDefault(); var li = mu.parentElement, nv2 = $g('dc-mnav'); if (li.classList.contains('is-open')) fermerU(li); else { ouvrirU(nv2, li); if (!li.classList.contains('dco__bq')) suivre(nv2, li); } return; }
    /* lien suivi depuis le tiroir, Retour armé : l'entrée du tiroir est retirée d'abord, la navigation suit (au plus 450 ms) */
    var lk = t.closest('#dc-mnav a[href]');
    if (lk && arme && !e.defaultPrevented && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && (!lk.target || lk.target === '_self') && lk.origin === location.origin) {
      e.preventDefault(); allerA = lk.href; clearTimeout(allerT); allerT = setTimeout(aller, 450); closeMenus(); return;
    }
    var inPanel = t.closest('#dc-mm .dcmm__panel, #dc-mnav .dcnav__panel');
    if (inPanel) { if (t.closest('a[href]')) closeMenus(); return; }
    var a = t.closest('a');
    if (a && lastDesk && (a.textContent || '').trim().toLowerCase() === 'boutique' && a.closest('#header-group, header')) {
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); var mm = $g('dc-mm'); if (isOpen(mm)) { closeBox(mm); syncBlur(); } else { openBox(mm, '.dcmm__panel'); } return;
    }
    if (isOpen($g('dc-mm')) || isOpen($g('dc-mnav'))) { if (t.closest('#header-group')) return; e.preventDefault(); e.stopPropagation(); closeMenus(); }
  }, true);

  /* ------------------------------------------------------------------ souris (ordinateur) : la porte change quand la souris s'y pose 120 ms */
  /* DC 04/11/2026, Marco : les portes « Marques » et « Par où commencer ? » s'ouvrent AU CLIC (et au clavier), plus au
     survol : l'ouverture après 120 ms de survol (écouteurs pointerover / pointerout) est retirée ; le clic passe par choisir() */

  /* ------------------------------------------------------------------ clavier */
  function focusables(p) { return [].slice.call(p.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (el) { return el.tabIndex >= 0 && visible(el); }); }
  document.addEventListener('keydown', function (e) {
    var mm = $g('dc-mm'), ae = document.activeElement;
    if (e.key === 'Escape') {
      var lb0 = lienBoutique(), rendre = isOpen(mm) && ae && (mm.contains(ae) || ae === lb0);
      closeMenus(); if (rendre && lb0) lb0.focus(); return;
    }
    if (e.key === 'Tab' && isOpen(mm)) {
      var lb = lienBoutique(), act = mm.querySelector('.dco__tab[aria-selected="true"]'), f = focusables(mm.querySelector('.dcmm__panel'));
      if (!e.shiftKey && ae === lb && act) { e.preventDefault(); act.focus(); return; }
      if (e.shiftKey && ae === act && lb) { e.preventDefault(); lb.focus(); return; }
      if (!e.shiftKey && f.length && ae === f[f.length - 1]) { e.preventDefault(); var nx = suivantEntete(lb); closeMenus(); if (nx) nx.focus(); return; }
    }
    var tab = ae && ae.closest && ae.closest('.dco__tab');
    if (tab && /^(ArrowLeft|ArrowRight|Home|End)$/.test(e.key)) {
      e.preventDefault(); var b = tab.closest('#dc-mm, #dc-mnav'), ts = portes(b), i = ts.indexOf(tab);
      var j = e.key === 'Home' ? 0 : e.key === 'End' ? ts.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + ts.length) % ts.length;
      choisir(b, ts[j], { focus: true, anim: true });
    }
  });

  /* ------------------------------------------------------------------ défilement / redimensionnement */
  function reposition() { var mm = $g('dc-mm'); if (isOpen(mm)) { placePanel(mm, '.dcmm__panel'); serreBientot(); } var nv = $g('dc-mnav'); if (isOpen(nv)) placePanel(nv, '.dcnav__panel'); }
  window.addEventListener('scroll', reposition, { passive: true });
  window.addEventListener('resize', function () {
    reposition(); var d = window.innerWidth >= 1000;
    if (d !== lastDesk) {
      lastDesk = d; killDrawer(); syncBlur();
      if (d) { closeBox($g('dc-mnav')); var m = document.querySelector('.header__row--top .header-menu, .header__row--top header-menu'); if (m) { m.removeAttribute('style'); var st = m.querySelectorAll('[style]'); for (var i = 0; i < st.length; i++) st[i].removeAttribute('style'); } setTimeout(function () { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }, 150); }
      else { closeBox($g('dc-mm')); }
    }
  });

  /* ------------------------------------------------------------------ téléphone : police des étagères et des marques */
  /* « DC Manrope Menu » (Manrope en 500, assets/dc-megamenu.css) : le tiroir est caché jusqu'au premier toucher, la police
     ne serait donc demandée qu'à ce moment-là. On la demande au repos, au téléphone seulement : c'est le fichier de
     Manrope que la page a déjà chargé (même adresse), rien n'est téléchargé en plus. */
  if (!lastDesk && document.fonts && document.fonts.load) {
    var police = function () { try { document.fonts.load("500 16px 'DC Manrope Menu'").catch(function () {}); } catch (e) {} };
    if (window.requestIdleCallback) requestIdleCallback(police, { timeout: 4000 }); else setTimeout(police, 2500);
  }
})();
